import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';

import 'bootstrap/dist/css/bootstrap.min.css';
import InsuranceCompany from "../../models/InsuranceCompany";

import Can from '../Can';
import { NotificationContext } from "../contexts/NotificationContext";
import ability from "../../Ability";
import { Redirect, withRouter } from "react-router-dom";
import * as Paths from "../../config/paths";
import Link from "react-router-dom/es/Link";

import { IoIosAddCircleOutline, IoMdCreate, IoMdRefreshCircle } from 'react-icons/io'
import { TAB_TITLE_BASE, TAB_TITLE_CONNECTOR } from "../../config/constants";
import { handleResponseError, handleStatusCode } from '../../service/errorHandlingService';
import { isUserAdminOrSuperAdmin } from '../../service/authenticationService';

class InsurancesIndex extends Component {

    static contextType = NotificationContext;

    constructor(props) {
        super(props);

        this.state = {
            insuranceCompanies: null,
            insuranceCompaniesToShow: null,
        };
    }

    initData() {
        InsuranceCompany.getInsuranceCompanies()
            .then(response => {
                if (response.status === 200) {
                    let InsuranceCompanies = response.body;
                    let allCompanies = InsuranceCompanies.map(insuranceCompany => new InsuranceCompany(insuranceCompany));

                    // Mock, um eine Company mit einem Fehler/Neustartbutton zu erzeugen:
                    /* let allCompanies = InsuranceCompanies.map(insuranceCompany => {
                        return insuranceCompany.id === 1
                            ? new InsuranceCompany({...insuranceCompany, crawling_error: true})
                            : insuranceCompany
                    }); */

                    allCompanies = allCompanies.sort((a, b) => {
                        if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
                            return -1;
                        } else if (a.name > b.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                    this.setState({
                        insuranceCompanies: allCompanies,
                        insuranceCompaniesToShow: allCompanies
                    });
                }
            })
            .catch(err => {
                handleResponseError(err)
            });
    }

    componentDidMount() {
        this.initData();
    }

    _saveFile(blob, filename) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = filename
        a.click();

        window.URL.revokeObjectURL(url);
    }

    updateAutoCrawlingOption = (insuranceCompany, event) => {
        const automaticCrawling = event.target.checked

        const updatedInsuranceCompany = Object.assign(
            Object.create(Object.getPrototypeOf(insuranceCompany)),
            insuranceCompany,
            {
                automaticCrawling
            }
        );

        this.setState((prevState) => {
            prevState.insuranceCompaniesToShow.map(item => {
                if (item.id === updatedInsuranceCompany.id) {
                    return updatedInsuranceCompany;
                }
                return item;
            });
        });

        // Note: Field name of the payload to update insurance companies is DIFFERENT from the field name returned from the backend
        const payload = {
            id: insuranceCompany.id,
            insurance_company_name: insuranceCompany.name,
            homepage: insuranceCompany.homepage,
            crawlable: automaticCrawling
        }

        const messageOption = automaticCrawling ? "aktiviert" : "deaktiviert"

        updatedInsuranceCompany.updateInsuranceCompany(payload)
            .then(response => {
                if (response.status === 200) {
                    this.context.showMessage(null,
                        `Autocrawling wurde für ${updatedInsuranceCompany.name} ${messageOption}.`,
                        "success");
                } else {
                    this.context.showMessage(null, "Unbekannter Fehler", "danger");
                }
            })
            .catch(err => {
                handleResponseError(err, [
                    {
                        status: 404,
                        message: "Die Firma wurde nicht gefunden"
                    },
                    {
                        status: 500,
                        message: err.response.body.errors === "Validation failed: Customer number has already been taken" 
                        ? "Die Kundennummer ist bereits vergeben"
                        : "Allgemeiner Serverfehler"
                    }
                ])
            });
    }

    restart = (event, insuranceCompany) => {
        const payload = {
            insurance_company_name: insuranceCompany.name,
            id: insuranceCompany.id,
            pause_crawling: false,
        }

        insuranceCompany.pause_crawling(payload)
            .then(response => {
                if (response.status === 200) {
                    this.context.showMessage(null, "Neustart wurde veranlasst.", "success");
                    this.initData()
                } else {
                    this.context.showMessage(null, "Unbekannter Fehler", "danger");
                }
            })
            .catch(err => {
                let showMessage = this.context.showMessage;

                if (!err.response) {
                    return showMessage(null, "Verbindungsfehler", "danger");
                }

                switch (err.response.status) {
                    case 403:
                        return showMessage(null, "Keine Berechtigung für die Aktion", "danger");
                    case 404:
                        return showMessage(null, "Die Versicherung wurde nicht gefunden", "danger");
                    case 422:
                        return showMessage(null, "Fehler bei der Verarbeitung des Versicherungsobjekts", "danger");
                    case 500:
                    default:
                        return showMessage(null, "Unbekannter Fehler", "danger");
                }
            });

    }

    render() {
        document.title = TAB_TITLE_BASE + TAB_TITLE_CONNECTOR + "Kundenübersicht";

        if (ability.cannot("index", "InsuranceCompany")) {
            return <Redirect to={Paths.PATH_ROOT} />
        }

        return (
            <div className={"fimo-content-page"}>
                <div className={"row fimo-background"} style={{ maxWidth: "100%", margin: "0px" }}>
                    <div className="col text-right" style={{ maxWidth: "100%" }}>
                        <Link to={Paths.PATH_INSURANCES_COMPANY_NEW}>
                            <button
                                className="btn btn-outline-form float-right">
                                <div>
                                    <IoIosAddCircleOutline />
                                </div>
                                Versicherer anlegen
                            </button>
                        </Link>
                    </div>
                </div>
                <div className={"row"} style={{ backgroundColor: "white", padding: "20px", marginRight: "75px", marginLeft: "75px" }}>

                    <div style={{ marginTop: "50px" }}>
                        {this.state.insuranceCompaniesToShow === null || this.state.insuranceCompaniesToShow === 0
                            ?
                            <span>Keine Firmen gefunden</span>
                            :
                            <div>
                                {this.renderClientCompaniesTable()}
                            </div>}
                    </div>
                </div>
            </div>
        )
    }

    renderClientCompaniesTable() {
        return (
            <div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Firmenname</th>
                            <th>Id</th>
                            <th>Status</th>
                            <th>Aktion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.insuranceCompaniesToShow.map(insuranceCompany => this.renderInsuranteCompanyCell(insuranceCompany))}
                    </tbody>
                </Table>
            </div>
        );
    }

    HandlerDelete = async (id) => {
        if (window.confirm('Versicherungsunternehmen endgültig löschen?')) {
            const showMessage = this.context.showMessage;
            const response = await InsuranceCompany.deleteInsurance(id)

            if (response.status === 200) {
                showMessage(null, "Account wurde gelöscht", "success");
                window.location.reload();
            } else {
                handleStatusCode(response.status, [
                    {
                        status: 404,
                        message: `Der Account mit ID=${id} wurde nicht gefunden.`
                    },
                ])
            }
        }
    }

    renderInsuranteCompanyCell(insuranceCompany) {
        const statusMessage = insuranceCompany.crawlable 
            ? insuranceCompany.crawling_error 
                ? "Fehler" 
                : "Aktiv"
            : ""

        const style = insuranceCompany.crawling_error
                        ? {color: "red"}
                        : {color: "green"}

        return (
            <tr key={insuranceCompany.id}>
                <td>{insuranceCompany.name}</td>
                <td style={{minWidth: "5ch"}}>{insuranceCompany.id}</td>
                <td style={{minWidth: "8ch"}}><span style={style}>{statusMessage}</span></td>
                <td style={{width: "28ch"}}>
                    <div>
                        {isUserAdminOrSuperAdmin() &&
                            <Can I="update" this={insuranceCompany}>
                                <Link to={`${Paths.PATH_INSURANCES_COMPANIES}/${insuranceCompany.id}/edit`}>
                                    <button
                                        className="btn btn-outline-form-slim">
                                        <IoMdCreate style={{ marginRight: "10px" }} />
                                        Bearbeiten
                                    </button>
                                </Link>
                            </Can>
                        }
                        {insuranceCompany.crawling_error && insuranceCompany.crawlable &&
                            <Can I="update" this={insuranceCompany}>
                                <button
                                    className="btn btn-outline-form-slim"
                                    onClick={(e) => this.restart(e, insuranceCompany)}>
                                    <IoMdRefreshCircle style={{ marginRight: "10px" }} />
                                        Neustart
                                    </button>
                            </Can>
                        }
                    </div>
                </td>
            </tr>
        );
    }
}

export default withRouter(InsurancesIndex);